import { GetServerSidePropsContext } from 'next'

import { serverSidePropsFor } from '@/utils/helpers.server'

import LandsSubPage from '.'

export const getServerSideProps = async (context: GetServerSidePropsContext) =>
  serverSidePropsFor(
    `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/lands/${context.query.color}/${context.query.slug}.json`,
  )

export default LandsSubPage
